import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createReview,
  fetchCount,
  fetchReviewByProduct,
  fetchReviewByUser,
} from "./reviewAPI";

const initialState = {
  value: 0,
  currentReview: [],
  userReview: [],
  reviewError: [],
};

export const createReviewAsync = createAsyncThunk(
  "review/createReview",
  async (review) => {
    const response = await createReview(review);
    return response.data;
  }
);
export const fetchReviewByProductAsync = createAsyncThunk(
  "review/fetchReviewByProduct",
  async (id) => {
    const response = await fetchReviewByProduct(id);
    return response.data;
  }
);
export const fetchReviewByUserAsync = createAsyncThunk(
  "review/fetchReviewByUser",
  async () => {
    const response = await fetchReviewByUser();
    return response.data;
  }
);

export const reviewSlice = createSlice({
  name: "review",
  initialState,

  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },

    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(createReviewAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createReviewAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.currentReview = [action.payload, ...state.currentReview];
      })
      .addCase(fetchReviewByProductAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchReviewByProductAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.currentReview = action.payload;
      })
      .addCase(fetchReviewByUserAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchReviewByUserAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.userReview = action.payload;
      });
  },
});

export const { increment, decrement, incrementByAmount } = reviewSlice.actions;

export const selectCurrentReview = (state) => state.review.currentReview;
export const selectUserReview = (state) => state.review.userReview;

export default reviewSlice.reducer;
